import { useEffect, useState } from 'react';
import { firestore } from '../stores/firestore';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { MessageFirestore } from '../types';

export const useSubscribeToMessages = (sessionId: string | undefined) => {
  const [messages, setMessages] = useState<MessageFirestore[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null); // 🆕

  useEffect(() => {
    if (!sessionId) return;

    const q = query(
      collection(firestore, 'chats', sessionId, 'messages'),
      orderBy('created_at', 'asc')
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const docs: MessageFirestore[] = snapshot.docs.map((doc) => {
          const data = doc.data();
          console.log(data)
          return {
            id: doc.id,
            parts: data.parts,
            role: data.role,
            references: data.references || [],
            created_at: data.created_at?.toDate?.() ?? new Date(),
          };
        });

        setMessages(docs);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [sessionId]);

  return { messages, loading, error };
};
